module.exports = __webpack_public_path__ + "static/media/vitronix.898b7d09.png";